export const TEXT_WARNING_MESSAGE =
  "Text too long. It should be less than 5000 characters.";

export const MAX_TEXT_SYMBOLS = 5000;
